<template>
  <AppHeader>Switch Profile</AppHeader>

  <div class="p-4">
    <div class="flex flex-col mt-1 text-xl text-gray-700 gap-y-3 divide-slate-100">

      <div v-for="login in logins" :key="login.id" @click="switchProfile(login)" class="flex items-center justify-start px-3 py-3 bg-white rounded-lg shadow cursor-pointer gap-x-3">
        <div class="flex items-center justify-center w-12 h-12 bg-gray-300 rounded-full">
          <i class="leading-none ion-md-person"></i>
        </div>
        <p>{{ login.name }}</p>
        <span v-if="login.api_token == $store.state.api_token" class="flex-grow text-right">
          <i class="text-2xl ion-md-checkmark"></i>
        </span>
      </div>

    </div>

    <div class="mt-5 text-center">
      <button @click="addProfile()" class="px-4 py-2 leading-none rounded-full bg-slate-300"><i class="ion-md-add"></i> Add Profile</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';

export default {
  name: 'SwitchProfile',
  mixins: [ mixin ],
  components: { AppHeader },
  data() {
    return {
      state: 'idle',
      logins: [],
    }
  },

  methods: {
    getData() {
      this.logins = JSON.parse(window.localStorage.getItem('dealer_logins'));
    },

    switchProfile(login) {
      if (login.api_token == this.$store.state.api_token) {
        alert('This is your current Profile');
        return;
      }

      window.localStorage.setItem('dealer_api_token', login.api_token);
      this.$store.state.api_token = login.api_token;
      this.$router.push({name: 'Dashboard'});
    },

    addProfile() {
      window.localStorage.removeItem('dealer_api_token');
      window.localStorage.removeItem('dealer_user');
      this.$router.push({name: 'Login'});
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
